export default "__VITE_ASSET__Dp7g6qFv__"